import { render, staticRenderFns } from "./ReportByPortal.vue?vue&type=template&id=6cc8f65c&"
import script from "./ReportByPortal.vue?vue&type=script&lang=js&"
export * from "./ReportByPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports